import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { aplicarCoresMarca, aplicarFaviconMarca, aplicarManifestMarca } from './brand';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30000 } },
});

aplicarCoresMarca();
aplicarFaviconMarca();
aplicarManifestMarca();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// PDV offline (Fase 1): registra o service worker só em produção — o app
// continua abrindo (e o PDV vendendo) mesmo se a internet cair depois da
// 1ª visita.
serviceWorkerRegistration.register();
